export default __webpack_public_path__ + "static/char-v-32-ja-9cb11aa35d2cda2cb9f42d36bf7146c5.mp4";